<div class="card" *ngIf="data && data.length">
  <h4 class="card-header"><mat-icon>contactless</mat-icon>&nbsp;<strong><span i18n>Podpora</span></strong></h4>
  <div class="card-body small">
    <div *ngFor="let d of data">
        <a title="{{d.nazov}}" target="_self" [href]="getDiskusiaUrl(d)">
          <img src="./assets/images/icon-diskusia.png">&nbsp;{{d.nazov}}
          <span class="badge text-bg-secondary">{{d.pocet}}</span>
        </a>
    </div>
  </div>
</div>
